module.exports = __webpack_public_path__ + "img/cancel.23fe0bd5.svg";